import { z } from 'zod'

const EnvSchema = z
  .object({
    VITE_API_BASE_URL: z.string().optional().default(''),
    VITE_POSTS_PAGE_SIZE: z.coerce.number().int().min(5).max(100).default(25),
    VITE_SENTRY_DSN: z.string().optional().default(''),
    VITE_SENTRY_ENVIRONMENT: z.string().optional().default('development'),
  })
  .passthrough()

export const env = EnvSchema.parse(import.meta.env)
